/**
 *
 * Asynchronously loads the DeleteApplicantModal component
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
